<template>
  <v-row>
    <v-col>
      <v-card-text>
        <v-card outlined :disabled="loading">
          <v-progress-linear v-show="loading" indeterminate color="primary"></v-progress-linear>
          <v-toolbar flat>
            <v-toolbar-title>Configuração</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn :loading="loadingSave" :disabled="loadingSave" @click="saveConfiguration()" x-large rounded color="primary"
              >Salvar</v-btn
            >
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col>
                <v-card outlined>
                  <v-card-title> Custo Executivo </v-card-title>
                  <v-card-text>
                    <v-select
                      :items="costs"
                      v-model="cost_executive_id"
                      item-text="name"
                      item-value="id"
                      outlined
                    ></v-select>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card outlined>
                  <v-card-title>URL de  Integração </v-card-title>
                  <v-card-text>
                    <v-text-field outlined v-model="url_integration" ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
                <v-col cols="3">
                <v-card outlined>
                  <v-card-title>Preço Unitário HH (R$)</v-card-title>
                  <v-card-text>
                    <vuetify-money v-model="unit_price_hh" outlined></vuetify-money>
                  </v-card-text>
                </v-card>
              </v-col>    
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Configuration",
  data() {
    return {
      loading: false,
      loadingSave: false,
      costs: [],
      cost_executive_id: null,
      url_integration: null,
      unit_price_hh: 0,
    };
  },
  created() {
    this.loadConfiguration();
    this.getDataCosts();
  },
  methods: {
    ...mapActions("Configuration", ["getCosts", "save", "index"]),
    getDataCosts() {
      this.getCosts()
        .then((response) => {
          this.costs = response.data;
        })
        .finally(() => {});
    },

    /**
     * CARREGA AS CONFIGURACOES
     */
    loadConfiguration() {
      this.loading = true;
      this.index()
        .then((response) => {
          this.cost_executive_id = response.data.cost_executive_id;
          this.url_integration = response.data.url_integration;
          this.unit_price_hh = response.data.unit_price_hh;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * Salva as configuracoes
     */
    saveConfiguration() {
      this.loadingSave = true
      let configuration = {
        cost_executive_id: this.cost_executive_id,
        url_integration: this.url_integration,
        unit_price_hh: this.unit_price_hh,
      };
      this.save(configuration)
        .then(() => {
            this.$toast.success("Configurações salvas !");
        })
        .finally(() => {
            this.loadingSave = false
        });
    },
  },
};
</script>

<style scoped>
.configuration {
  padding: 2rem;
}
</style>
